import templateUrl from './preview-signature-modal.component.html'
import angular from 'angular';
import * as pdfjsLib from 'pdfjs-dist/build/pdf';
import pdfWorker from 'pdfjs-dist/build/pdf.worker.entry';
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorker;


export const PreviewSignatureModalComponent = {
    templateUrl,
    controller: PreviewSignatureController,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    }
}


function PreviewSignatureController($scope, $sce, $window, $timeout) {
    'ngInject';
    const vm = this;

    let pdfDoc = null;
    vm.baseScale = 1;
    vm.zoomFactor = 1;
    vm.pdfUrl;
    vm.acknowledgement = false;
    vm.submit = submit;
    vm.drawing = drawing;
    vm.sign;
    vm.boundingBox = {
        width: 700,
        height: 300,
    };
    vm.$onInit = function () {
        console.log(vm.resolve);
        vm.allowApprove = vm.resolve.allowApprove;
        vm.allowSign = vm.resolve.allowSign;
        vm.pdfUrl = $sce.trustAsResourceUrl(vm.resolve.previewUrl);
    }

    vm.$postLink = function () {
        $timeout(() => waitForContainerAndRender(), 700);
        // Adjust bounding box on resize
        angular.element($window).on('resize', handleResize);
    }


    //vm.nextPage = () => {
    //    if (vm.currentPage < vm.totalPages) {
    //        vm.currentPage++;
    //        renderPage(vm.currentPage);
    //    }
    //};


    //vm.prevPage = () => {
    //    if (vm.currentPage > 1) {
    //        vm.currentPage--;
    //        renderPage(vm.currentPage);
    //    }
    //};

    vm.zoomIn = () => {
        vm.zoomFactor += 0.1;
        renderAllPages();
    };

    vm.zoomOut = () => {
        vm.zoomFactor = Math.max(0.1, vm.zoomFactor - 0.1);
        renderAllPages();
    };


    function loadPdf(url) {
        const loadingTask = pdfjsLib.getDocument(url);
        loadingTask.promise.then(function (pdf) {
            pdfDoc = pdf;
            vm.totalPages = pdf.numPages;

            const container = document.getElementById('pdfContainer');
            const tempPagePromise = pdf.getPage(1);

            tempPagePromise.then(page => {
                const unscaledViewport = page.getViewport({ scale: 1 });
                /*const containerWidth = container.clientWidth || 600;*/
                //const containerStyle = window.getComputedStyle(container);
                //const paddingLeft = parseFloat(containerStyle.paddingLeft || '0');
                //const paddingRight = parseFloat(containerStyle.paddingRight || '0');
                const containerWidth = container.clientWidth;

                vm.baseScale = containerWidth / unscaledViewport.width;
                renderAllPages();
            });
            $scope.$apply();
        }).catch(function (err) {
            console.log('Error loading PDF:', err);
        });
    }

    function renderAllPages() {

        const container = document.getElementById('pdfContainer');
        if (!container) {
            console.log('pdfContainer not found');
            return;
        }

        console.log("PDF Container width:", container.clientWidth);
        container.innerHTML = ''; // Clear previous


        for (let pageNumber = 1; pageNumber <= pdfDoc.numPages; pageNumber++) {
            renderPage(pageNumber, container);
        }
    }

    function waitForContainerAndRender(retries = 30) {
        const container = document.getElementById('pdfContainer');
        if (!container) return;

        const width = container?.clientWidth || 0;
        console.log(`Retry ${30 - retries}: container width = ${width}px`);

        if (width > 300) { // good size
            loadPdf(vm.resolve.previewUrl);
        } else if (retries > 0) {
            $timeout(() => waitForContainerAndRender(retries - 1), 300);
        } else {
            console.log("Container not ready after multiple retries");
        }
    }

    function renderPage(pageNumber, container) {
        pdfDoc.getPage(pageNumber).then(page => {
            const viewport = page.getViewport({ scale: 1 }); // base viewport, scale=1 to get original size

            // Get container width (actual pixel width available)
            const containerWidth = container.clientWidth;
            if (!containerWidth) {
                console.log('Container width is zero or undefined');
                return;
            }

            // Calculate scale so page fits container width exactly
            const scale = containerWidth / viewport.width;

            // Apply zoom factor on top of this scale
            const effectiveScale = scale * vm.zoomFactor;

            // Create viewport with effective scale
            const scaledViewport = page.getViewport({ scale: effectiveScale });

            const canvas = document.createElement('canvas');
            canvas.className = 'pdf-page-canvas';

            const context = canvas.getContext('2d');
            const dpr = window.devicePixelRatio || 1;

            // Set canvas width and height in device pixels for crispness
            canvas.width = scaledViewport.width * dpr;
            canvas.height = scaledViewport.height * dpr;

            // Set CSS width to fill container width (100%), height auto to maintain aspect ratio
            canvas.style.width = '100%';
            canvas.style.height = scaledViewport.height + 'px';
            //canvas.style.height = (scaledViewport.height / scaledViewport.width * 100) + '%'; // maintain aspect ratio

            // Scale context for device pixel ratio
            context.setTransform(dpr, 0, 0, dpr, 0, 0);

            // Render the page on canvas
            page.render({ canvasContext: context, viewport: scaledViewport });

            container.appendChild(canvas);
            //const effectiveScale = baseScale * vm.zoomFactor;
            //const viewport = page.getViewport({ scale: effectiveScale });

            //const canvas = document.createElement('canvas');
            //canvas.className = 'pdf-page-canvas';

            //const context = canvas.getContext('2d');
            //const dpr = window.devicePixelRatio || 1;

            //canvas.width = viewport.width * dpr;
            //canvas.height = viewport.height * dpr;
            //canvas.style.width = viewport.width + 'px';
            //canvas.style.height = viewport.height + 'px';

            //context.setTransform(dpr, 0, 0, dpr, 0, 0);

            //page.render({ canvasContext: context, viewport });
            //container.appendChild(canvas);
        });
    }


    function handleResize() {
        const container = document.getElementById('pdfContainer');
        if (!container) {
            console.log('pdfContainer not found');
            return;
        }
        //vm.boundingBox.width = $window.innerWidth * 0.9;
        //vm.boundingBox.height = $window.innerHeight * 0.5;
        $timeout(() => {
            container.innerHTML = ''; // clear existing canvases
            renderAllPages();
        }, 100);

        if (!$scope.$$phase) {
            $scope.$apply();
        }
    }

    function drawing(draw) {
        if (!draw) {
            vm.sign = $scope.accept();
        }
    }


    function submit() {
        if (!vm.acknowledgement) {
            alert("Please acknowledge before submitting.");
            return;
        }
        if (!vm.sign || vm.sign.isEmpty) {
            alert("Signature is required!");
            return;
        } else {
            let result = {
                dataUrl: vm.sign.dataUrl,
                sign: "yolo" // set other variables
            }
            vm.close({ $value: result });
        }
    }
}

export const PreviewSignatureModal = {
    component: "apexPreviewSignatureModal",
    windowClass: 'xx-dialog pagespinner',
    size: 'lg',
    backdrop: 'static'
}
